<template>
  <address class="contact">
    <div class="contact__heading">
      Contact
    </div>

    <p class="contact__phone">
      <a href="tel:+0882349800">088-23 49 800</a>
      <br>
      (bereikbaar van ma. t/m za.)
    </p>

    <p class="contact__email">
      <a href="mailto:info@boumanenpotter.nl">info@boumanenpotter.nl</a>
      <br>
      (binnen 2 werkdagen reactie)
    </p>
  </address>
</template>

<style>
@import url("~layers/app/components/App/Contact.css");
</style>
